import React from "react";
import { useLocation } from "react-router-dom";
import * as Icons from "lucide-react";
import { PageHeader, ComingSoon, Footer } from "@/components/common/Page";

const META = {
    clans: { title: "Clans", icon: "Shield", sub: "Form a clan, recruit officers and sync with Discord roles." },
    lfg: { title: "Looking For Group", icon: "Users", sub: "Find squads across PS5, Xbox and PC." },
    maps: { title: "Maps", icon: "Map", sub: "Server maps, monuments and seeds." },
    market: { title: "Market", icon: "ShoppingCart", sub: "Community shops, kits and rewards." },
    leaderboards: { title: "Leaderboards", icon: "Trophy", sub: "Top raiders, builders and survivors." },
    messages: { title: "Messages", icon: "MessageSquare", sub: "Direct messages and squad chat." },
    support: { title: "Support", icon: "LifeBuoy", sub: "Open a ticket with the staff team." },
};

export default function PlayerGeneric() {
    const loc = useLocation();
    const id = loc.pathname.split("/")[2];
    const m = META[id] || { title: id, icon: "Circle", sub: "" };
    const Icon = Icons[m.icon] || Icons.Circle;
    return (
        <div data-testid={`player-${id}`}>
            <PageHeader title={m.title} subtitle={m.sub} />
            <ComingSoon title={m.title} icon={Icon} />
            <Footer />
        </div>
    );
}
